export default [
    {
      "fragrance_type_id": "fragrance-cbeea764-a1fa-4186-955d-aed28bcc62d1",
      "fragrance_name_en": "Mango, earthy, herbal"
    },
    {
      "fragrance_type_id": "fragrance-05ee2495-b193-485f-8f68-d8bc4c81285b",
      "fragrance_name_en": "Pine, rosemary"
    },
    {
      "fragrance_type_id": "fragrance-2a4fea53-4d87-4f5c-a9c4-1089d9b08f95",
      "fragrance_name_en": "Citrus"
    },
    {
      "fragrance_type_id": "fragrance-53dbb259-3528-4cc1-954b-304e2bf2d953",
      "fragrance_name_en": "Spicy, pepper"
    },
    {
      "fragrance_type_id": "fragrance-4f5cf38c-99a2-4203-a798-a98354414696",
      "fragrance_name_en": "Woody & floral"
    },
    {
      "fragrance_type_id": "fragrance-ac9675b8-0b86-43cf-b0a3-292f25d57811",
      "fragrance_name_en": "Sweet & floral"
    },
    {
      "fragrance_type_id": "fragrance-9c916095-6a98-404a-b814-52a2e2679e3b",
      "fragrance_name_en": "Myrcene"
    },
    {
      "fragrance_type_id": "fragrance-190332ec-ac23-43b4-a579-7297bd681d54",
      "fragrance_name_en": "Humulene"
    },
    {
      "fragrance_type_id": "fragrance-24bb753c-41b4-41cd-b20e-0c217610e3fa",
      "fragrance_name_en": "Eucalyptol"
    },
    {
      "fragrance_type_id": "fragrance-d62d15e8-f30f-4d6d-b03a-6fa75f1c2a98",
      "fragrance_name_en": "Ocimene"
    }
  ]